import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "bt_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const login = async (password) => {
  const { data } = await axios.post(`${API}/admin/login`, { password });
  setToken(data.token);
  return data.token;
};

export const fetchContent = async () => {
  const { data } = await axios.get(`${API}/content`);
  return data;
};

export const updateContent = async (payload) => {
  const { data } = await axios.put(`${API}/admin/content`, payload, { headers: authHeaders() });
  return data;
};

export const listTeam = async () => {
  const { data } = await axios.get(`${API}/admin/team`, { headers: authHeaders() });
  return data;
};
export const createMember = async (m) => (await axios.post(`${API}/admin/team`, m, { headers: authHeaders() })).data;
export const updateMember = async (id, m) => (await axios.put(`${API}/admin/team/${id}`, m, { headers: authHeaders() })).data;
export const deleteMember = async (id) => (await axios.delete(`${API}/admin/team/${id}`, { headers: authHeaders() })).data;

export const listLeads = async () => (await axios.get(`${API}/admin/leads`, { headers: authHeaders() })).data;
export const deleteLead = async (id) => (await axios.delete(`${API}/admin/leads/${id}`, { headers: authHeaders() })).data;

export const uploadFile = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await axios.post(`${API}/admin/upload`, fd, {
    headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
  });
  return data.url; // /api/uploads/...
};

export const resolveAdminImg = (url) => {
  if (!url) return "";
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};
